import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axios from "axios";
import { ReactQueryKey } from "../../types";
import { IGetProductReturn } from "./getProduct";

export interface IGetCompanyParams {
    code: string
}

export interface IRangeDate {
    startDate: string | null;
    endDate: string | null;
}

export interface IGetCompanyReturn extends IGetProductReturn {
    rangeDate?: IRangeDate,
    cig?: string[] | null,
    mandatoryDossier: boolean,
    companyId: string,
    name: string,
    description: string,
    firstInvoiceRecipient: string,
    creditType: string
}

export const getCompany = async (businessAgreement: string, pickUpDate: string, tenant?: string, dealer?: string): Promise<IGetCompanyReturn | null> => {
    const response = await axios.get('/booking/instool/productAffilieted', {
        params: {
            businessAgreement,
            pickUpDate,
            tenant,
            dealer
        }
    }).catch((error) => {
        console.log('Error', error);
        return null;
    });
    if (response && response.data) {
        return response.data;
    }

    return null; 
};

export const useCompanyQueryObserver = (params: {segment: string, tenant: string, dealer: string}) => {
    return useQuery<IGetCompanyReturn | null>({
        queryKey: [ReactQueryKey.Product, {segment: params.segment, tenant: params.tenant as string, dealer: params.dealer as string}],
        enabled: false
    })
};

export const useCompanyQuery = (params?: any, options?: UseQueryOptions<IGetCompanyReturn | null>) => {
    return useQuery<IGetCompanyReturn | null>(
        [ReactQueryKey.Product, {segment: params.segment, tenant: params.tenant as string, dealer: params.dealer as string}],
        () => {
            if (!params.code || !params?.tenant || !params?.dealer) {
                return null;
            }
            return getCompany(params.code, params.pickupDate, params.tenant, params.dealer);
        },
        options
    )
};
